<template>
  <v-footer
    app
    height="auto"
  >
    <v-layout
      justify-center
      row
    >
      <v-flex class="shrink py-3">
        &copy; {{ new Date().getFullYear() }} — <strong>qap.red</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
</style>
